import { render, staticRenderFns } from "./client-download.vue?vue&type=template&id=562691b0&"
import script from "./client-download.vue?vue&type=script&lang=js&"
export * from "./client-download.vue?vue&type=script&lang=js&"
import style0 from "./client-download.vue?vue&type=style&index=0&id=562691b0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports